import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_URL } from "./config/endpoint";
import App from "./App";

const EYESOL_URL_STAGING = "https://staging.eyesol.net";
const EYESOL_URL_PRODUCTION = "https://eyesol.net";

// Loading component
const LoadingScreen = () => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      flexDirection: "column",
    }}
  >
    <div>Checking authentication...</div>
    <div style={{ marginTop: "20px" }}>
      <div
        style={{
          border: "4px solid #f3f3f3",
          borderTop: "4px solid #3498db",
          borderRadius: "50%",
          width: "40px",
          height: "40px",
          animation: "spin 2s linear infinite",
        }}
      ></div>
    </div>
    <style jsx>{`
      @keyframes spin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }
    `}</style>
  </div>
);

const AuthWrapper = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(null); // null = loading, true = authenticated, false = not authenticated
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkAuthentication();
  }, []);

  const checkAuthentication = async () => {
    try {
      setIsLoading(true);
      console.log("Checking authentication...");

      const response = await axios.get(`${API_URL}/receive-token`, {
        withCredentials: true,
      });

      console.log("Auth response:", response.data);

      // Check if the response indicates successful authentication
      if (
        response.data &&
        response.data.original_response &&
        response.data.original_response.success === true
      ) {
        console.log("Authentication successful");
        setIsAuthenticated(true);
      } else {
        console.log(
          "Authentication failed:",
          response.data?.original_response?.message || "Unknown error"
        );
        setIsAuthenticated(false);
        // Redirect to EyeSol sign-in page
        redirectToSignIn();
      }
    } catch (error) {
      console.error("Authentication check failed:", error);
      setIsAuthenticated(false);
      // Redirect to EyeSol sign-in page on error
      redirectToSignIn();
    } finally {
      setIsLoading(false);
    }
  };

  const redirectToSignIn = () => {
    console.log("Redirecting to EyeSol sign-in page...");
    const currentUrl = window.location.href;

    if (!currentUrl.includes("staging")) {
      window.location.href = `${EYESOL_URL_PRODUCTION}/users/sign_in/?redirect_url=${currentUrl}`;
    } else {
      window.location.href = `${EYESOL_URL_STAGING}/users/sign_in/?redirect_url=${currentUrl}`;
    }

    // // Redirect to the EyeSol staging sign-in page
    // window.location.href = `${EYESOL_URL}/users/sign_in/?redirect_url=${currentUrl}`;
  };

  // Show loading screen while checking authentication
  if (isLoading || isAuthenticated === null) {
    return <LoadingScreen />;
  }

  // If authenticated, show the main app
  if (isAuthenticated === true) {
    return <App />;
  }

  // If not authenticated, show a message (though user should be redirected)
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        flexDirection: "column",
      }}
    >
      <div>Redirecting to sign in...</div>
    </div>
  );
};

export default AuthWrapper;
